export default __webpack_public_path__ + "static/media/checking_results_thumbnail.155f593b.png";